const maskAsCurrency = `let sanitizedValue = value
if (value.includes('.')) {
  let segments = value.split('.')
  segments = segments.map((seg) => seg.replace(/\\D+/g, ''))
  return \`\${segments[0].replace(/\\D+/g, '')}.\${segments.slice(1).join('')}\`
} else {
  return value.replace(/\\D+/g, '')
}`
module.exports = {
  FREQUENT_PAYOR_ACH_ONLY: true,
  STATE_ABBR: 'PA',
  STATE_NAME: 'Pennsylvania',
  STATE_ORG_TITLE: '',
  LOGO_LINK_URL: 'https://www.dos.pa.gov/Pages/default.aspx',
  CUSTOM_HOME_TAB_TITLE: 'Business Services',
  CUSTOM_TAB_TITLE: 'An Official Pennsylvania Government Website',
  HOME_TOP_BANNER_IMAGE: 'pa-banner.jpg',
  HOME_BUTTONS_UNDER_FOLD: true,
  HOME_TOP_BANNER_TEXT: `
    <h2>File Your Business</h2>
    <h3>With the Department of State</h3>
    <a class='btn btn-secondary' href="/forms/business">Start Here</a>
  `,
  FAVICON_FILE_NAME: 'pa_favicon.ico',
  SHOW_FREE_RECEIPT_IF_WAIVED: true,
  USE_PAYPAL_CHECKOUT: false,
  SHOPPING_CART: true,
  HOME_HIDE_AUTH_HINT: false,
  LOGO_FILENAME: 'pabanner.png',
  SYSTEM_NICKNAME: 'Business Filing Services',
  HOME_SUBTITLE:
    "Welcome to the Pennsylvania Department of State's online filing portal. Business Filing Services enables businesses to file, search and order records online. Whether you are starting a new business, updating or requesting business records, filing a Uniform Commercial Code financing statement, searching for a registered business, fictitious name or trademark, this hub consolidates all your information needs. Get started by selecting any of the online services below.",
  FREQUENT_PAYOR_LABEL: 'Customer Deposit Account',
  DEPRECATE_IE: true,
  DEPRECATE_NON_CHROMIUM_EDGE: true,
  PAYMENT_ALLOW_AMEX: false,
  ALLOW_NATIVE_CHECKOUT: true,
  PREPAID_REFILL_METHOD: 'elavon',
  SYSTEM_ID_LABEL: 'File Number',
  DOUBLE_COLUMN_PUBLIC_LOGIN: false,
  FORM_REVISION_HISTORY: true,
  ALLOW_USER_PROFILE_EDITING: true,
  HAS_OKTA_LOGIN: false,
  HAS_KEYSTONE_LOGIN: true,
  LOGIN_TITLE: 'Pennsylvania Login',
  // LOGIN_SEAL_FILENAME: "seal_color.png",
  PUBLIC_LOGIN_LABEL: 'User Email',
  REVERSE_LOGIN_COLUMNS: false,
  EDIT_ACCOUNT_LABEL: 'My Account',
  MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON: false,
  ALLOW_COPY_REQUEST: false,
  ALLOW_PUBLIC_CERTIFICATE_REQUEST: true,
  ALLOW_CERTIFICATION_REQUEST: true,
  COMBINED_CERTIFICATE_VERIFICATION: true,
  CERTIFICATE_VERIFICATION_ERROR: 'A Certificate Verification Number is required.',
  CERTIFICATE_VERIFICATION_TITLE: 'Certificate Verification',
  CERTIFICATE_VERIFICATION_LABEL: 'Certificate Verification No.',
  CERTIFICATE_VERIFICATION_DESCR:
    'To verify a certificate or certified copy issued by the Pennsylvania Department of State, enter the Certificate Verification Number located on your certificate or certified copy.',
  ALLOW_REINSTATEMENT_AR_MODAL: false,
  SHOW_SEARCH_ACCORDIONS: true,
  BUSINESS_SEARCH_EXTRA_DISCLAIMER:
    'The information contained in this web site is supplied from records submitted to the Department for filing and the Department makes no representations or warranties, either express or implied, as to the accuracy of any posted information and assumes no responsibility for any errors or omissions contained therein. The presence of a business registration on the web site does not in any way constitute an endorsement by the Department of State. The Department is not responsible for any loss, consequence or damages resulting directly or indirectly from reliance on the accuracy, reliability or timeliness of the information that is provided. No posted information or material provided is intended to constitute legal or professional advice.',
  UCC_SEARCH_EXTRA_DISCLAIMER:
    'Uniform Commercial Code (UCC) records are public notice of secured transactions. A UCC financing statement indicates a commercial agreement between a debtor and a secured party. Filing with this office serves to perfect a security interest in the named collateral and establish priority in case of debtor default or bankruptcy. This search will give basic information about the debtor and the secured party for each filed document. The information contained in this web site is supplied from records submitted to the Department for filing and the Department makes no representations or warranties, either express or implied, as to the accuracy of any posted information and assumes no responsibility for any errors or omissions contained therein.',
  TRADEMARK_SEARCH_EXTRA_DISCLAIMER:
    'The information contained in this web site is supplied from records submitted to the Department for filing and the Department makes no representations or warranties, either express or implied, as to the accuracy of any posted information and assumes no responsibility for any errors or omissions contained therein. The presence of a registration on the web site does not in any way constitute an endorsement by the Department of State. The Department is not responsible for any loss, consequence or damages resulting directly or indirectly from reliance on the accuracy, reliability or timeliness of the information that is provided. No posted information or material provided is intended to constitute legal or professional advice.',
  CROP_SEARCH_EXTRA_DISCLAIMER:
    "Under Pennsylvania law <a target='_blank' href='https://www.legis.state.pa.us/cfdocs/legis/LI/consCheck.cfm?txtType=HTM&ttl=15&div=0&chpt=1&sctn=9&subsctn=0'>(15 Pa.C.S. § 109)</a>, entities required to provide a registered office address in any document filed in the Department of State may enter into a contract for the services of a Commercial Registered Office Provider (CROP) and may list the name of the CROP in lieu of providing a registered office address. This option is also available for any corporation or association that does not have a physical location or mailing address in the Commonwealth of Pennsylvania. Listing a CROP without having entered into a contract to acquire the services of that CROP could subject a filer to civil and criminal penalties. Fictitious name registrations may not use a CROP. The information contained in this web site is supplied from records submitted to the Department for filing and the Department makes no representations or warranties, either express or implied, as to the accuracy of any posted information and assumes no responsibility for any errors or omissions contained therein. The presence of a CROP registration on the web site does not in any way constitute an endorsement by the Department of State. The Department is not responsible for any loss, consequence or damages resulting directly or indirectly from reliance on the accuracy, reliability or timeliness of the information that is provided.",
  FOOTER_LINKS: false,
  EXCLUDE_LOGO_FROM_MOBILE_MENU: true,
  CUSTOM_HEADER:
    '<header>' +
    '<nav class="language-bar bg-gry" id="language-bar">' +
    '<a target="_blank" href="http://www.pa.gov/" title="PA.GOV | The Official Website for the Commonwealth of Pennsylvania.">' +
    '<img src="/img/pa-keystone-large.png" alt="PA Keystone Logo" class="h3 lang-logo">' +
    '</a>' +
    '<div class="language-bar-left">' +
    '<a target="_blank" href="http://www.pa.gov/" title="PA.GOV | The Official Website for the Commonwealth of Pennsylvania.">' +
    '<span>' +
    'An Official <strong>Pennsylvania</strong> Government Website' +
    '</span>' +
    '</a>' +
    '</div>' +
    '</nav>' +
    '</header>',
  CUSTOM_FOOTER:
    '<nav id="copyright" class="clearfix row">' +
    '<ul class="medium-12 large-6 columns">' +
    '<li>' +
    '<a href="https://www.pa.gov/accessibility-policy/" alt="Accessibilty">' +
    '<span>Accessibility</span>' +
    '</a>' +
    '</li>' +
    '<li>' +
    '<a href="https://www.pa.gov/privacy-policy/" alt="Privacy &amp; Disclaimers">' +
    '<span>Privacy &amp; Disclaimers</span>' +
    '</a>' +
    '</li>' +
    '<li>' +
    '<a href="https://www.pa.gov/translation-disclaimer/" alt="Translation Disclaimer">' +
    '<span>Translation Disclaimer</span>' +
    '</a>' +
    '</li>' +
    '<li>' +
    '<a href="https://www.pa.gov/security-policy/" alt="Security">' +
    '<span>Security</span>' +
    '</a>' +
    '</li>' +
    '</ul>' +
    '<p class="medium-12 large-6 columns">' +
    'Copyright &#169; {{FULL_YEAR}} Commonwealth of Pennsylvania. All rights reserved.' +
    '</p>' +
    '</nav>',
  UPLOAD_FILE_FORMAT_MERGEABLE_ERROR: 'The uploaded file must be in {{FILE_FORMAT}} format.',
  UPLOAD_FILE_SIZE_MERGEABLE_ERROR:
    'The uploaded file must be no larger than {{FILE_SIZE}} megabytes.',
  MAX_FILE_UPLOAD_SIZE: 30000000, // This is in bytes
  UCC_SEARCH_ALLOW_SEARCH_TYPE: true,
  WIZARD_ON_EARLY_EXIT_MESSAGE: `Are you sure you want to exit this form? Any unsaved data you have entered will be lost.\n\nSelect “OK” to exit, or Select “Cancel” to return to the form.`,
  WIZARD_ALT_HELP_STYLE: true,
  DEFAULT_SEARCH_PLACEHOLDER: 'Search by name or file number',
  CONDITIONALLY_SHOW_SIGNATURES_FOR_CORRECTIONS: true,
  SEARCH_HAS_PAGINATION: false,
  SEARCH_IS_SORTABLE: true,
  PASS_ITEM_GUIDS_ON_CHECKOUT: true,
  DEFAULT_INPUT_MAX_LENGTH: 300,
  HIDE_FOOTER_FORMS_MANAGER: true,
  UCC_SEARCH_REQUEST_TYPE_LABEL_1: 'Search report',
  UCC_SEARCH_REQUEST_TYPE_LABEL_2: 'Search report and ALL copies',
  UCC_SEARCH_REQUEST_TYPE_LABEL_3: 'Copy (single record number)',
  UCC_SEARCH_ONLY_REQUIRE_LAST_NAME: true,
  UCC_SEARCH_ALLOW_START_DATE: true,
  UCC_NUMBERS_ONLY_SEARCH: true,
  MY_WORK_QUEUE_DISABLE_EMPTY_STATE: false,
  HOME_LOGIN_HINT: 'Login Required for Options Below',
  RA_NONCOMMERCIAL_LABEL: 'Noncommercial or Individual',
  ALLOW_REVOKE_OWN_ACCESS_ONLY: false,
  USER_ACCESS_LEVEL_MANAGEMENT: true,
  USER_ACCESS_LEVEL_MANAGEMENT_USE_PUBLIC: true,
  SHOW_ACCESS_LEVEL_TYPE_DROPDOWN: false,
  SHOW_REQUEST_ACCESS_PUBLIC: true,
  SHOW_REQUEST_ACCESS_STAFF: false,
  PIN_REQUEST_ATTESTATIONS: true,
  PIN_REQUEST_DESCRIPTION: `To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.`,
  PIN_REQUEST_SUCCESS_MESSAGE:
    'The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.',
  PUBLIC_LOGIN_CREATE_DESCRIPTION: `### Welcome to PA Online!:

    If this is your first visit you _**must create an account to:**_

    - File a UCC lien`,
  CERTIFICATION_ADDRESS_LABEL: 'Requester address',
  DATA_REQUEST_DESCRIPTION:
    'Records will appear in this list for six months following the listed completion date.',
  UNSUPPORTED_BROWSER_MESSAGE:
    'In order to guarantee the security of your data, a modern browser is **required** to access this site.\n\nThe latest versions of the following browsers may be used to access this site:',
  HIDE_EDIT_CONDITIONS: true,
  CORRESPONDENCE_HEADER: 'pabanner.png',
  CORRESPONDENCE_CONCLUSION:
    'You may correct your submission as detailed above and resubmit for review by logging into your PA online account.',
  CORRESPONDENCE_ADDRESS: [
    'Pennsylvania Secretary of State',
    '302 North Office Building, 401 North Street',
    'Harrisburg, PA 17120',
  ],
  ADDITIONAL_ROUTES: {
    dataRequests: true,
    genericPins: true,
    healthCareDirective: false,
    lists: false,
    dashboard: true,
    externalHelp: 'https://www.dos.pa.gov/BusinessCharities/Business/Resources/Pages/default.aspx',
    // systemAdministration: [
    // {
    //   title: 'Manage Users',
    //   parameter: 'manage-users',
    //   componentName: 'ManageUsers',
    // },
    // {
    //   title: 'Manage User Groups',
    //   parameter: 'manage-user-groups',
    //   componentName: 'ManageUserGroups',
    // },
    // ],
  },
  CERTIFICATION_FORM_ENTITY_REQUIREMENTS: {
    8322: 'BUSINESS',
    8370: 'TRADEMARK',
  },
  OPEN_REPORT_VIEWER_ON_WEB_FILED_PROCESSING: false,
}
